var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M61.92 12H30.08C16.28 12 8 20.24 8 34.08V65.88C8 79.76 16.28 88 30.08 88H61.88C75.72 88 83.96 79.76 83.96 65.92V34.08C84 20.24 75.72 12 61.92 12Z",
    fill: "#F2654E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0799 11.9199C76.9199 4.71988 69.9199 4.55988 62.5599 11.9199L58.0399 16.3999C57.6399 16.7999 57.5199 17.3599 57.6799 17.8799C60.4799 27.6799 68.3199 35.5199 78.1199 38.3199C78.2399 38.3599 78.4399 38.3599 78.5599 38.3599C78.9599 38.3599 79.3599 38.1999 79.6399 37.9199L84.0799 33.4399C87.7199 29.7999 89.5199 26.3199 89.5199 22.7599C89.5199 19.1599 87.7199 15.5999 84.0799 11.9199Z",
    fill: "#F2654E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4404 41.6801C70.3604 41.1601 69.3204 40.6401 68.3604 40.0401C67.5604 39.5601 66.7604 39.0401 66.0004 38.4801C65.3604 38.0801 64.6404 37.4801 63.9204 36.8801C63.8404 36.8401 63.6004 36.6401 63.2804 36.3201C62.0404 35.3201 60.7204 33.9601 59.4804 32.4801C59.4004 32.4001 59.1604 32.1601 58.9604 31.8001C58.5604 31.3601 57.9604 30.6001 57.4404 29.7601C57.0004 29.2001 56.4804 28.4001 56.0004 27.5601C55.4004 26.5601 54.8804 25.5601 54.4004 24.5201C53.8804 23.4001 53.4804 22.3601 53.1204 21.3601L31.6004 42.8801C30.2004 44.2801 28.8404 46.9201 28.5604 48.8801L26.8404 60.8001C26.4804 63.3201 27.1604 65.6801 28.7204 67.2401C30.0404 68.5601 31.8404 69.2401 33.8404 69.2401C34.2804 69.2401 34.7204 69.2001 35.1604 69.1601L47.0404 67.4801C49.0004 67.2001 51.6404 65.8801 53.0404 64.4401L74.5604 42.9201C73.5604 42.6001 72.5604 42.1601 71.4404 41.6801Z",
    fill: "#F2654E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.7dca422766ed1540a5cf3f03ec7e55a0.svg";
export { ForwardRef as ReactComponent };